import styled, { css } from 'styled-components';
import { buttonBase, hoverOpacity, focusRing } from '@/styles/mixins';
import { ButtonProps } from '@/Models';

export const Button = styled.button<ButtonProps>`
  ${buttonBase}
  box-sizing: border-box;
  border: 1px solid ${({ theme }) => theme.colors.button.border};
  border-radius: 16px; /* Premium spec */
  text-transform: capitalize;
  height: 30px; /* Premium spec - fixed height */
  width: 90px; /* Premium spec - fixed width */
  font-size: 0.75rem; /* 12px - Premium spec */
  font-weight: 400; /* normal - Premium spec */
  padding: 0px 12px; /* Horizontal padding only - Premium spec */
  margin: 0px 0px 0.5rem;
  color: ${({ theme }) => theme.colors.button.text} !important;
  -webkit-text-fill-color: ${({ theme }) => theme.colors.button.text} !important;
  background: linear-gradient(${({ theme }) => theme.colors.button.gradientStart}, ${({ theme }) => theme.colors.button.gradientEnd});
  transition: 0.25s ease-in-out; /* Premium spec */
  line-height: 1.2; /* Better vertical centering */
  
  /* Force white text on all child elements */
  *, *::before, *::after {
    color: ${({ theme }) => theme.colors.button.text} !important;
    -webkit-text-fill-color: ${({ theme }) => theme.colors.button.text} !important;
  }
  
  /* Sizes */
  ${({ $size = 'md', $fullWidth }) => {
    switch ($size) {
      case 'sm':
      case 'sml':
        return css`
          height: 28px;
          font-size: 0.75rem;
          padding: 0px 10px;
          width: 80px;
        `;
      case 'lg':
        return css`
          height: 36px;
          font-size: 0.75rem;
          padding: 0px 16px;
          width: ${$fullWidth ? '90%' : '120px'};
        `;
      default:
        return css`
          height: 30px;
          font-size: 0.75rem;
          padding: 0px 12px;
          width: 90px;
        `;
    }
  }}
  
  ${hoverOpacity}
  
  &:active:not(:disabled) {
    transform: translateY(1px);
  }
  
  &:disabled {
    opacity: 0.5; /* Premium spec */
  }
  
  ${focusRing}
`;